import { type RouteRecordRaw } from 'vue-router'

export const brandKitRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/BrandKitLogoMenuView.vue'),
        meta: { title: 'brand-kit' },
        name: 'brand.brand-kit.logo-menu',
        path: 'logo-menu',
      },
      {
        component: async () => import('../views/BrandKitMediaGalleryView.vue'),
        meta: { title: 'brand-kit' },
        name: 'brand.brand-kit.media-gallery',
        path: 'media-gallery',
      },
    ],
    component: async () => import('../views/BrandKitLayout.vue'),
    meta: {
      roles: ['pb:super'],
      title: 'brand-kit',
    },
    name: 'brand.brand-kit',
    path: 'brand-kit',
    redirect: { name: 'brand.brand-kit.logo-menu' },
  },
]
